import clsx from "clsx";

type InputProps = {
  type: "text" | "number";
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  id?: string;
  classes?: string;
  disabled?: boolean;
};

export default function Input({
  type,
  value,
  onChange,
  onBlur,
  id,
  classes,
  disabled,
}: InputProps) {
  return (
    <input
      id={id}
      className={clsx(
        "dark:bg-[#333] border border-[#444] rounded px-1 py-1 text-xs focus:outline-none focus:border-[#2185d0] focus:shadow-[inset_0_-100px_0_rgba(33,133,208,0.15)]",
        classes,
      )}
      type={type}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
    />
  );
}
